import React from 'react'
import image from '../src/assets/images/right-tech (1).png'

const Footer = () => {
  return (
   <div>
    <footer class="footer-section">
        <div class="container">
           
            <div class="footer-content pt-5 pb-5">
                <div class="row">
                    <div class="col-xl-4 col-lg-4 mb-50">
                        <div class="footer-widget">
                            <div class="footer-logo">
                                <a href="/#home"><img src={image} class="img-fluid" alt="logo"/></a>
                            </div>
                            <div class="footer-text">
                                <p>Round Point Tech, a US-based Software Development and Technology consulting firm, offers a comprehensive range of tailored solutions to clients across the United States, as well as state-of-the-art solutions aimed at enhancing your business. Our services are designed to meet the requirements of businesses of all sizes, including small, medium, and large enterprises.</p>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 mb-30">
                        <div class="footer-widget">
                            <div class="footer-widget-heading">
                                <h3>Useful Links</h3>
                            </div>
                            <ul>
                                <li><a href="/#home">Home</a></li>
                                <li><a href="/#About">About</a></li>
                                <li><a href="/#Services">Services</a></li>
                                <li><a href="/#Career">Career</a></li>
                                <li><a href="/#contact">Contact</a></li>
                                <li><a href="/#Services">Software Development</a></li>
                                <li><a href="/#Services">Quality Assurance</a></li>
                                <li><a href="/#Services">Network Infrastructure</a></li>
                                <li><a href="/#Services">Staff Augmentation</a></li>
                                <li><a href="/#Services">AI</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 mb-50">
                        <div class="footer-widget">
                            <div class="footer-widget-heading">
                                <h3>Follow us</h3>
                            </div>
                            <div class="footer-social-icon">
                              
                              <a href="	/#home" target="_blank"><i class="fa fa-facebook-f"></i></a>
                              <a href="/#home" target="_blank"><i class="fa fa-twitter-square"></i></a>
                              <a href="/#home" target="_blank"><i class="fa fa-linkedin-square"></i></a>
                          </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="copyright-area">
            <div class="container">
                
                    <div class="text-center">
                        <div class="copyright-text">
                            <p>© 2023 Copyright Round Point Technologies Inc. All Rights Reserved <br/>Designed by <a href="https://www.knackhook.com/" target="_blank">KnackHook</a></p>
                        </div>
                    </div>
                    
                
            </div>
        </div>
    </footer>

   </div>
   
  )
}

export default Footer